const blogDetailRoute = {
  path: '/blog/:slug',
  indexable: true,
  staticHtml: false,
  navLabel: null,
  title: 'ブログ記事 | 揺腕法',
  description:
    '揺腕法にまつわる記事や読み物をご紹介します。',
};

const yowanRouteManifest = [
  {
    path: '/',
    indexable: true,
    staticHtml: true,
    navLabel: 'ホーム',
    title: '揺腕法',
    description:
      '揺腕法は『刀禅』の創始者・小用茂夫が発表した、新しい身体運動法です。その特色は、「腕を振る」という極シンプルな運動を通じて、身体の基準性「垂直性・水平性」を整えることで、すべての運動の出発点となる自分の身体を再構築するということにあります。',
  },
  {
    path: '/founder',
    indexable: true,
    staticHtml: true,
    navLabel: '創始者',
    title: '創始者紹介 | 揺腕法',
    description:
      '揺腕法の創始者・小用茂夫の略歴と、刀禅のご紹介です。',
  },
  {
    path: '/reviews',
    indexable: true,
    staticHtml: true,
    navLabel: 'ご感想',
    title: 'ご感想 | 揺腕法',
    description:
      '揺腕法を体験された方や、書籍『揺腕法』を読まれた方から寄せられたご感想をご紹介します。',
  },
  {
    path: '/blog',
    indexable: true,
    staticHtml: true,
    navLabel: 'ブログ',
    title: 'ブログ | 揺腕法',
    description:
      '揺腕法にまつわるお知らせや読み物を掲載しています。',
  },
  blogDetailRoute,
  {
    path: '/blog-author',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ執筆者ページ | 揺腕法',
    description:
      'ブログ執筆者が自身の投稿を確認・作成・編集するページです。',
  },
  {
    path: '/blog-author/posts',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ投稿一覧 | 揺腕法',
    description:
      'ブログ執筆者が自身の投稿一覧を確認するページです。',
  },
  {
    path: '/blog-author/posts/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ投稿作成 | 揺腕法',
    description:
      'ブログ執筆者が新しい投稿を作成するページです。',
  },
  {
    path: '/blog-author/posts/:postId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ投稿編集 | 揺腕法',
    description:
      'ブログ執筆者が自身の投稿を編集するページです。',
  },
  {
    path: '/login',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ログイン',
    description:
      'メンバー向けのログインページです。',
  },
  {
    path: '/password-reset',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'パスワード再設定',
    description:
      'パスワード再設定メールを送信するページです。',
  },
  {
    path: '/password-reset/confirm',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'パスワード再設定',
    description:
      '受け取ったメールのリンクから新しいパスワードを設定します。',
  },
  {
    path: '/password-setup/confirm',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '初回パスワード設定',
    description:
      '受け取ったメールのリンクから初回パスワードを設定します。',
  },
  {
    path: '/onboarding',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '情報入力フォーム',
    description:
      'ご案内メールから開く情報入力フォームです。',
  },
  {
    path: '/logout',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ログアウト',
    description:
      'ログアウトページです。',
  },
  {
    path: '/stakeholder',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '関係者ページ | 揺腕法',
    description:
      '講師・主催者が担当教室・講座、担当セミナー、プロフィールを確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/classes',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当教室・講座 | 揺腕法',
    description:
      '講師・主催者が担当教室・講座と申込状況を確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/classes/:classId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当教室・講座詳細 | 揺腕法',
    description:
      '講師・主催者が担当教室・講座の詳細を確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/classes/:classId/applications',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当教室・講座申込一覧 | 揺腕法',
    description:
      '講師・主催者が担当教室・講座の申込状況を確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/profile',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '関係者プロフィール | 揺腕法',
    description:
      '講師・主催者が自身の公開プロフィールを確認・更新する関係者向けページです。',
  },
  {
    path: '/stakeholder/instructor-profile',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '講師プロフィール | 揺腕法',
    description:
      '講師が自身の公開プロフィールを確認・更新する関係者向けページです。',
  },
  {
    path: '/stakeholder/organizer-profile',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '主催者プロフィール | 揺腕法',
    description:
      '主催者が自身の公開プロフィールを確認・更新する関係者向けページです。',
  },
  {
    path: '/stakeholder/seminars',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当セミナー | 揺腕法',
    description:
      '講師・主催者が担当セミナーと申込状況を確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/seminars/:eventId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当セミナー詳細 | 揺腕法',
    description:
      '講師・主催者が担当セミナーの詳細を確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/seminars/:eventId/applications',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当セミナー申込一覧 | 揺腕法',
    description:
      '講師・主催者が担当セミナーの申込状況を確認する関係者向けページです。',
  },
  {
    path: '/stakeholder/seminars/:eventId/application-messages',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '担当セミナー申込メッセージ | 揺腕法',
    description:
      '講師・主催者が担当セミナーの申込メッセージを確認する関係者向けページです。',
  },
  {
    path: '/contact',
    indexable: true,
    staticHtml: true,
    navLabel: 'お問い合わせ',
    title: 'お問い合わせ | 揺腕法',
    description:
      '揺腕法の内容、講座情報、地方出張、個人レッスン、取材などに関するお問い合わせはこちらからお願いします。',
  },
  {
    path: '/mail-magazine',
    indexable: true,
    staticHtml: true,
    navLabel: 'メルマガ',
    title: 'メルマガ登録 | 揺腕法',
    description:
      '揺腕法の情報を月に2〜3回メールでお届けします。ご希望の方はこちらからご登録ください。',
  },
  {
    path: '/notifications/unsubscribe',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'メール配信停止',
    description:
      'メール配信の停止手続きを行うページです。',
  },
  {
    path: '/mypage',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'マイページ',
    description:
      '揺腕法の会員向けトップページ。会員情報と主要導線の受け皿として扱う。',
  },
  {
    path: '/mypage/seminars',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '参加セミナー',
    description:
      '揺腕法のマイページ内のセミナー申込管理ページ。本人の参加予定、参加済み、キャンセル済み申込を扱う。',
  },
  {
    path: '/mypage/profile',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'プロフィール更新',
    description:
      '揺腕法のプロフィール更新ページ。会員プロフィールの更新画面として扱う。',
  },
  {
    path: '/admin',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'Dashboard',
    description:
      '揺腕法の管理画面トップページ。コンテンツ、会員、教室・セミナー、権限、通知の管理入口です。',
  },
  {
    path: '/admin/mail',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'メール',
    description:
      '管理者が送受信メールのスレッドを確認するページです。',
  },
  {
    path: '/admin/mail/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '新規メール',
    description:
      '管理者が任意の宛先へメールを送信するページです。',
  },
  {
    path: '/admin/mail/threads/:threadId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'メールスレッド',
    description:
      '管理者がメールスレッドの送受信履歴を確認し返信するページです。',
  },
  {
    path: '/admin/mail/threads/:threadId/status',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'メール対応状態変更',
    description:
      '管理者がメールスレッドの対応状態を変更するページです。',
  },
  {
    path: '/admin/deploy/staging-domain-fallback',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'Staging表示切替',
    description:
      'StagingのHerokuapp URLで表示するサイトを切り替える管理ページ。実ドメイン未設定期間の検証用です。',
  },
  {
    path: '/admin/notifications',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '通知履歴',
    description:
      '通知の送信履歴を確認する管理ページ。送信判断や宛先設定の編集は扱わない。',
  },
  {
    path: '/admin/notifications/policies',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '通知ルール',
    description:
      '通知イベントごとの送信判断、宛先グループ、テンプレートを確認する管理ページ。',
  },
  {
    path: '/admin/notifications/policies/:eventKey',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '通知ルール詳細',
    description:
      '通知ルールの詳細を確認し、送信判断だけを更新する管理ページ。',
  },
  {
    path: '/admin/notifications/recipients',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '通知宛先',
    description:
      '通知全体の宛先グループと、通知可能な宛先台帳を確認する管理ページ。',
  },
  {
    path: '/admin/notifications/recipients/:recipientId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '通知宛先詳細',
    description:
      '通知宛先の由来、関連導線、カテゴリ別受信設定を確認する管理ページ。',
  },
  {
    path: '/admin/notifications/:dispatchId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '通知詳細',
    description:
      '送信履歴の宛先、件名、本文、送信元情報、失敗理由を確認する管理ページ。',
  },
  {
    path: '/admin/content/founder',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '創始者管理',
    description:
      '創始者ページに掲載するコンテンツの一覧管理ページです。',
  },
  {
    path: '/admin/content/founder/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '創始者コンテンツ新規作成',
    description:
      '創始者ページに掲載するコンテンツを新規作成する管理ページです。',
  },
  {
    path: '/admin/content/founder/:cassetteId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '創始者コンテンツ編集',
    description:
      '創始者ページに掲載するコンテンツを編集する管理ページです。',
  },
  {
    path: '/admin/content/blog',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ管理',
    description:
      'ブログ記事の一覧、公開状態、表示内容を管理するページです。',
  },
  {
    path: '/admin/content/blog/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ新規作成',
    description:
      'ブログ記事を新規作成する管理ページです。',
  },
  {
    path: '/admin/content/blog/:blogId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ編集',
    description:
      'ブログ記事の内容や公開状態を編集する管理ページです。',
  },
  {
    path: '/admin/content/blog-authors',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ執筆者管理',
    description:
      'ブログ執筆者の認証招待、著者プロフィール、投稿公開権限を管理するページです。',
  },
  {
    path: '/admin/content/blog-authors/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ執筆者招待',
    description:
      'ブログ執筆者を新規招待し、著者プロフィールと投稿公開権限を設定するページです。',
  },
  {
    path: '/admin/content/blog-authors/:accessId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ブログ執筆者編集',
    description:
      'ブログ執筆者の著者プロフィール、投稿公開権限、有効状態を編集するページです。',
  },
  {
    path: '/admin/content/news',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'お知らせ管理',
    description:
      'お知らせ記事の一覧、公開状態、表示内容を管理するページです。',
  },
  {
    path: '/admin/content/news/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'お知らせ新規作成',
    description:
      'お知らせ記事を新規作成する管理ページです。',
  },
  {
    path: '/admin/content/news/:newsId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'お知らせ編集',
    description:
      'お知らせ記事の内容や公開状態を編集する管理ページです。',
  },
  {
    path: '/admin/content/page-contents',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ページコンテンツ管理',
    description:
      '揺腕法のページコンテンツ管理ページ。公開ページに表示するページコンテンツの画像や表示状態を扱う。',
  },
  {
    path: '/admin/content/page-contents/:pageKey/:slotKey/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'ページコンテンツ編集',
    description:
      '揺腕法のページコンテンツ編集ページ。定義済み表示枠の公開状態と画像を更新する。',
  },
  {
    path: '/admin/members',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '会員管理',
    description:
      '会員情報の一覧を確認し、管理するページです。',
  },
  {
    path: '/admin/members/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '会員新規作成',
    description:
      '会員情報を新規作成する管理ページです。',
  },
  {
    path: '/admin/members/:memberId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '会員編集',
    description:
      '会員情報を編集する管理ページです。',
  },
  {
    path: '/admin/operators',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '管理者管理',
    description:
      '管理者として登録されている人物プロフィールの一覧を確認するページです。',
  },
  {
    path: '/admin/operators/:accessId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '管理者編集',
    description:
      '管理者人物プロフィールを編集するページです。管理権限の編集とは分けて扱います。',
  },
  {
    path: '/admin/applicants',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '問い合わせ・申込者管理',
    description:
      '問い合わせや申込など、外部接点から登録された人物情報の一覧を確認するページです。',
  },
  {
    path: '/admin/applicants/:applicantId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '問い合わせ・申込者詳細',
    description:
      '問い合わせ・申込者の発生元、本人入力依頼の状態、同一メールアドレスの観測履歴を確認するページです。',
  },
  {
    path: '/admin/events/classes',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '教室管理',
    description:
      '常設教室の一覧、公開状態、開催情報を管理するページです。',
  },
  {
    path: '/admin/events/seminars',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー管理',
    description:
      'セミナーの一覧、公開状態、開催枠、申込状況を管理するページです。',
  },
  {
    path: '/admin/events/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '教室・セミナー新規作成',
    description:
      '教室またはセミナーを新規作成する管理ページです。',
  },
  {
    path: '/admin/events/series/:seriesId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'シリーズ編集',
    description:
      'セミナーシリーズの基本情報を編集する管理ページです。',
  },
  {
    path: '/admin/events/series/:seriesId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'シリーズ詳細',
    description:
      'セミナーシリーズの基本情報と、配下のセミナーを確認する管理ページです。',
  },
  {
    path: '/admin/events/series/:seriesId/application-messages',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'シリーズ申込メッセージ一覧',
    description:
      'シリーズ配下のセミナー申込メッセージをまとめて確認する管理ページです。',
  },
  {
    path: '/admin/events/:eventId/cancel',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー中止',
    description:
      'セミナー中止処理の影響範囲と通知ルールを確認し、中止を実行する専用ページです。',
  },
  {
    path: '/admin/events/:eventId/reactivate',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー運用再開',
    description:
      '中止済みセミナーの強い停止状態だけを解除し、公開・申込受付・開催コマ設定を維持して運用再開する専用ページです。',
  },
  {
    path: '/admin/events/:eventId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '教室・セミナー編集',
    description:
      '教室またはセミナーの基本情報、開催枠、申込関連の導線を管理する編集ページです。',
  },
  {
    path: '/admin/events/:eventId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー詳細',
    description:
      'セミナーの基本情報、シリーズ、開催枠、申込状況への導線をまとめて確認する管理ページです。',
  },
  {
    path: '/admin/events/classes/:classId/applications',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '教室申込者一覧',
    description:
      '常設教室の開催情報ごとの申込者一覧を確認する管理ページです。',
  },
  {
    path: '/admin/events/classes/applications/:applicationId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '教室申込詳細',
    description:
      '教室申込の申込者情報、希望開催情報、受付状態を確認する管理ページです。',
  },
  {
    path: '/admin/events/seminars/applications/:applicationId',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー申込詳細',
    description:
      'セミナー申込の申込時点情報、現在の人物台帳、同一メールアドレスの観測履歴を確認する管理ページです。',
  },
  {
    path: '/admin/events/:eventId/applications',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー参加者一覧',
    description:
      'セミナー参加者の一覧を確認し、連絡などの運用導線へ進む管理ページです。',
  },
  {
    path: '/admin/events/:eventId/application-messages',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー申込メッセージ一覧',
    description:
      'セミナー申込時に入力されたメッセージをまとめて確認する管理ページです。',
  },
  {
    path: '/admin/events/:eventId/applications/mail',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '参加者メール送信',
    description:
      'セミナー参加者への一斉送信や個別連絡を作成する管理ページです。',
  },
  {
    path: '/admin/events/facilities',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '施設管理',
    description:
      'セミナーや教室で使用する施設の一覧を管理するページです。',
  },
  {
    path: '/admin/events/facilities/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '施設新規作成',
    description:
      'セミナーや教室で使用する施設を新規作成する管理ページです。',
  },
  {
    path: '/admin/events/facilities/:facilityId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '施設編集',
    description:
      '施設情報と部屋の紐づきを編集する管理ページです。',
  },
  {
    path: '/admin/events/rooms',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '部屋管理',
    description:
      '施設に紐づく部屋の一覧を管理するページです。',
  },
  {
    path: '/admin/events/rooms/:roomId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '部屋編集',
    description:
      '施設に紐づく部屋情報を編集する管理ページです。',
  },
  {
    path: '/admin/events/instructors',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '講師管理',
    description:
      '講師プロフィールの一覧と、教室・セミナーへの割当対象を管理するページです。',
  },
  {
    path: '/admin/events/instructors/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '講師新規作成',
    description:
      '講師プロフィールを新規作成する管理ページです。',
  },
  {
    path: '/admin/events/instructors/:instructorId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '講師編集',
    description:
      '講師プロフィール、稼働状態、公開状態を編集する管理ページです。',
  },
  {
    path: '/admin/events/organizers',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '主催者管理',
    description:
      '教室・セミナーの主催者一覧を管理するページです。',
  },
  {
    path: '/admin/events/organizers/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '主催者新規作成',
    description:
      '個人または団体の主催者を新規作成する管理ページです。',
  },
  {
    path: '/admin/events/organizers/:organizerId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '主催者編集',
    description:
      '主催者情報、会員との紐づき、稼働状態、公開状態を編集する管理ページです。',
  },
  {
    path: '/admin/access/member',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '会員資格管理',
    description:
      '会員資格の一覧を管理するページです。',
  },
  {
    path: '/admin/access/member/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '会員資格新規作成',
    description:
      '会員資格を新規作成する管理ページです。',
  },
  {
    path: '/admin/access/member/:accessId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '会員資格編集',
    description:
      '会員資格を編集する管理ページです。',
  },
  {
    path: '/admin/access/operator',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '管理権限管理',
    description:
      '管理権限の一覧を管理するページです。',
  },
  {
    path: '/admin/access/operator/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '管理権限新規作成',
    description:
      '管理権限を新規作成する管理ページです。',
  },
  {
    path: '/admin/access/operator/:accessId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '管理権限編集',
    description:
      '管理権限を編集する管理ページです。',
  },
  {
    path: '/admin/content/reviews',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '受講者の声管理',
    description:
      '受講者の声の一覧と公開状態を管理するページです。',
  },
  {
    path: '/admin/content/reviews/new',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '受講者の声新規作成',
    description:
      '受講者の声を新規作成する管理ページです。',
  },
  {
    path: '/admin/content/reviews/:reviewId/edit',
    indexable: false,
    staticHtml: false,
    navLabel: null,
    title: '受講者の声編集',
    description:
      '受講者の声を編集する管理ページです。',
  },
  {
    path: '/classes',
    indexable: true,
    staticHtml: true,
    navLabel: '教室・講座',
    title: '教室・講座 | 揺腕法',
    description:
      '揺腕法の常設クラス、セミナー、体験会の情報をご案内します。',
  },
  {
    path: '/seminars',
    indexable: true,
    staticHtml: true,
    navLabel: null,
    title: 'セミナー・体験会 | 揺腕法',
    description:
      '揺腕法のセミナー・体験会の開催情報をご案内します。',
  },
  {
    path: '/classes/:eventId',
    indexable: true,
    staticHtml: false,
    navLabel: null,
    title: '教室・講座詳細 | 揺腕法',
    description:
      '揺腕法の常設クラス詳細ページです。開催情報、講師、会場、申込案内をご確認いただけます。',
  },
  {
    path: '/seminars/:eventId',
    indexable: true,
    staticHtml: false,
    navLabel: null,
    title: 'セミナー・体験会詳細 | 揺腕法',
    description:
      '揺腕法のセミナー・体験会詳細ページです。開催日程、会場、講師、申込案内をご確認いただけます。',
  },
];

const getYowanRouteMeta = (routePath) => {
  const exactMatch = yowanRouteManifest.find((route) => route.path === routePath);

  if (exactMatch) {
    return exactMatch;
  }

  return yowanRouteManifest.find((route) => {
    if (!route.path.includes(':')) {
      return false;
    }

    const pattern = new RegExp(`^${route.path.replace(/:[^/]+/g, '[^/]+')}$`);
    return pattern.test(routePath);
  }) || null;
};

const isYowanRoutePath = (routePath) => Boolean(getYowanRouteMeta(routePath));

module.exports = yowanRouteManifest;
module.exports.yowanRouteManifest = yowanRouteManifest;
module.exports.getYowanRouteMeta = getYowanRouteMeta;
module.exports.isYowanRoutePath = isYowanRoutePath;
